import getPersonaRequest from 'owa-service/lib/factory/getPersonaRequest';
import GetPersonaRequest from 'owa-service/lib/contract/GetPersonaRequest';
import GetPersonaJsonResponse from 'owa-service/lib/contract/GetPersonaJsonResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import getPersonaOperation from 'owa-service/lib/operation/getPersonaOperation';

export function getOwsPersonaByEmailAddress(emailAddress: string): Promise<PersonaType> {
    const request: GetPersonaRequest = getPersonaRequest({
        EmailAddress: { EmailAddress: emailAddress },
    });

    return getPersonaOperation({
        Header: getJsonRequestHeader(),
        Body: request,
    }).then((response: GetPersonaJsonResponse) => {
        if (response.Body && response.Body.ResponseCode === 'NoError') {
            return response.Body.Persona;
        } else {
            throw new Error('GetPersonaByEmailAddress failed');
        }
    });
}
